import { useLinkCardForm } from "@/components/shared/forms/link-card-form";
import type { LinkCard } from "@stackje/common/config";

interface EditLinkCardProps {
  card: LinkCard;
  cardIndex: number;
}

export function EditLinkCard({ card }: EditLinkCardProps) {
  const { formContent, previewContent, toggleType: toggleLinkType, shuffleColors, handleSubmit } = useLinkCardForm({
    initialData: {
      title: card.title || "",
      description: card.description || "",
      links: card.links.map((link) => ({
        title: link.title || "",
        url: link.url,
        description: "description" in link ? link.description || "" : "",
        image:
          "image" in link && link.image
            ? link.image
            : undefined,
      })),
      type: card.type,
      colors: card.colors,
    },
    mode: "edit",
  });

  return {
    formContent,
    previewContent,
    toggleLinkType,
    shuffleColors,
    handleSubmit,
  };
}
